const parseDataString = dataString => {
  const separatorIndex = dataString.indexOf(',')

  if (!dataString.startsWith('data:') || separatorIndex === -1) {
    return {
      content: dataString,
      contentType: 'text/plain;charset=utf-8'
    }
  }

  const contentType = dataString.slice(5, separatorIndex) || 'text/plain;charset=utf-8'
  const rawContent = dataString.slice(separatorIndex + 1)

  try {
    return {
      content: decodeURIComponent(rawContent),
      contentType
    }
  } catch (error) {
    return {
      content: rawContent,
      contentType
    }
  }
}

export default ({ dataString, fileName }) => {
  const { content, contentType } = parseDataString(dataString)
  const blob = new Blob([content], { type: contentType })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
